// extracted by mini-css-extract-plugin
export default {"root":"tile-module--root--d9c87","image":"tile-module--image--6b2d9","title":"tile-module--title--8af31"};